import React, { useEffect, useState, useRef } from "react"; 
import api from "../api/api";
import AcademicYear from "../AcademicYear";
import SchoolIcon from "@mui/icons-material/School";
import HighAveragesPage from "./ReportCard/HighAveragesPage";
import BulkTestScorePage from "./ReportCard/BulkTestScorePage";
import PeopleIcon from "@mui/icons-material/People";
import PaidIcon from "@mui/icons-material/Paid";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { FaClipboardList } from 'react-icons/fa';
import Expenditure from "../pages/FinancialReports/Expenditure";

import PaymentRequestView from "../pages/Paymentrequest/PaymentRequestView";
import AssignmentView from "../pages/Teachers/AssignmentView";
import GetStudentNotes from "../pages/Teachers/GetStudentNotes";
import PaymentRequestDetails from "../pages/Paymentrequest/PaymentRequestDetails";

import UserSearchBox from "./UserDetails/UserSearchBox";
import { Link } from 'react-router-dom';
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { FaDoorOpen, FaArrowRight } from "react-icons/fa";

import AcademicReport from "./AcademicReport";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from 'react-router-dom'; 
import gaasLogo from "./messiahnewlogo.jpg";
import bgImage from "./laughdark.jpg"; 
import Concern from "./Concern";

import Swal from "sweetalert2";
import "./AvatarUpdate.css"; 
import {
  Avatar, Badge, Menu, Grow,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText, CircularProgress,
  Collapse,
} from "@mui/material";
import { useTheme, ThemeProvider } from "@mui/material/styles";
import Notice from "../components/ChatApp/Notice";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Bar } from "react-chartjs-2";

import {
  FaChalkboardTeacher,
  FaChalkboard,
  FaBookReader,
  FaBook,
  FaMoneyBill,
  FaGraduationCap,
  FaSchool,
  FaReceipt,
  FaPagelines,
  FaCashRegister,
  FaIdCard, FaUserFriends,
} from "react-icons/fa";

import Register from "../pages/Register";
import AcademicYearPost from "./AcademicYearPost";
import Schedule from "../pages/Schedule/Schedule";
import SchedulePage from "../pages/Schedule/SchedulePage";
import SchedulePageTrack from "../pages/Schedule/SchedulePageTrack";
import SubjectCountView from "./Class/Subjects/SubjectCountView";
import GradeClassCount from "./Class/GradeClassCount";
import StudentsAdmission from "./StudentsAdmission";
import FinancialPaymentRecord from "./FinancialPaymentRecord";

import AttendanceData from "../pages/Attendance/AttendanceData";
import AttendanceRecord from "../pages/Attendance/AttendanceRecord";
import TeacherDataForm from "../pages/Teachers/TeacherDataForm"; 
import TeacherAttendanceData from "../pages/Teachers/TeacherAttendanceData";

import PeriodReport from "../pages/Reportcard/PeriodReport";
import ReportCard from "../NewDashboard/ReportCard";
import GradeDistribution from "../pages/Reportcard/GradeDistribution";
import DivisionList from "./Division/DivisionList";
import SubjectViewList from "./Class/Subjects/SubjectViewList";
import ClassViewList from "./Class/ClassViewList";
import AdminPublishGrades from "./AdminPublishGradesPopup";
import SchoolFeesData from "./SchoolFeesData"; 
import TestAttachmentView from "./TestAttachmentView";
import StudentStatsDashboard from "./StudentStatsDashboard";
import StudentStatusSummary from "./StudentStatusSummary";
import PaymentRecord from "./PaymentRecord";


import NotificationIcon from "../components/ChatApp/NotificationIcon";

import AddClass from "../pages/Students/AddClass";
import AddSubject from "../pages/Students/AddSubject";
import CreateDivision from "../pages/Students/CreateDivision";
import Payroll from "../pages/Teachers/Payroll";
import SupportStaff from "../pages/Teachers/SupportStaff";
import SalaryAdvance from "../pages/Teachers/SalaryAdvance";
import FinanceDashboard from "../pages/FinancialReports/FinanceDashboard";
import OtherFee from "../pages/FinancialReports/OtherFee"; 
import FeesSummary from "../pages/FinancialReports/FeesSummary";
import MonthlyFinancialRecord from "../pages/FinancialReports/MonthlyFinancialRecord";
import Loan from "../pages/FinancialReports/Loan";
import TestPraint from "../pages/Teachers/TestPraint";

import UserDetailsPage from "./UserDetails/UserDetailsPage";

import AdminResetPassword from "../AdminResetPassword";

const drawerWidth = 270;

const AdminDashboard = () => {

  const [user, setUser] = useState(null);
  const [total, setTotal] = useState(null); //expenditure
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(true); // loading user profile & first counts
  const [loadingCounts, setLoadingCounts] = useState(false); // for first counts fetch only

// paymentrequest



// paymentrequestENDS 

  //handlelogout
  const [loadingLogout, setLoadingLogout] = useState(false);
  const navigate = useNavigate();

  const [selectedUser, setSelectedUser] = useState(null); // Search for users

  const [activeComponent, setActiveComponent] = useState("admindashboard");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openGradesMenu, setOpenGradesMenu] = useState(false);

      //Notification
      const token = localStorage.getItem("access");
      const [notifications, setNotifications] = useState([]);
      const [clickedNotificationId, setClickedNotificationId] = useState(null);
      const [unreadCount, setUnreadCount] = useState(0);
      const [anchorEl, setAnchorEl] = useState(null);

  const [openAddClass, setOpenAddClass] = useState(false);
  const [openAddSubject, setOpenAddSubject] = useState(false);
  const [openCreateDivision, setOpenCreateDivision] = useState(false);
///Handle Profile Change //
  const [tempImage, setTempImage] = useState(null);
  const [overlay, setOverlay] = useState(false);
//Profile change end
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const firstCountsLoad = useRef(true); 

  const isMobilee = useMediaQuery("(max-width:600px)"); // breakpoint for mobile
  const [startIndex, setStartIndex] = useState(0);

   const buttons = [
    { label: "ADD USER", component: "register" },
    { label: "Create Schedule", component: "schedule" },
    { label: "View Schedules", component: "schedulepage" },
    { label: "Track Schedules", component: "schedulepagetrack" },
    { label: "Payroll", component: "payroll" },
    { label: "Support staff", component: "supportstaff" },
    { label: "Prepay", component: "salaryadvance" },
  ];

  const handleNext = () => {
    if (startIndex + 2 < buttons.length) setStartIndex(startIndex + 2);
  };

  const handlePrev = () => {
    if (startIndex - 2 >= 0) setStartIndex(startIndex - 2);
  };

  const displayedButtons = isMobile ? buttons.slice(startIndex, startIndex + 2) : buttons;

  useEffect(() => {
    const fetchTotalExpenditure = async () => {
      try {
        const response = await api.get("/expenditures/total_amount/");
        setTotal(response.data.total_amount);
      } catch (error) {
        console.error("Error fetching total expenditure:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTotalExpenditure();
  }, []);

  // expenditure end

  // Fetch user profile once on mount
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data } = await api.get("user-profile/");
        setUser(data);
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };
    fetchUserProfile();
  }, []);

  // Fetch counts silently when dashboard is active
  useEffect(() => {
    if (activeComponent === "admindashboard") {
      const fetchCounts = async () => {
        if (firstCountsLoad.current) {
          setLoadingCounts(true); // show spinner only first time
        }
        try {
          const { data } = await api.get("/api/users/admin-counts/");
          setCounts(data);
        } catch (err) {
          console.error("Error fetching admin counts:", err);
        } finally {
          if (firstCountsLoad.current) {
            setLoadingCounts(false);
            firstCountsLoad.current = false;
            setLoading(false); // done loading initial data
          }
        }
      };
      fetchCounts();
    }
  }, [activeComponent]);


// paymentrequeststarts 


// paymentrequestENDS 


  // Logout
const handleLogout = () => {
  setLoadingLogout(true);

  api.post('api/logout/', {})  // changed here
    .then(() => {
      localStorage.removeItem('access');
      setLoadingLogout(false);
      navigate('/login');
    })
    .catch((error) => {
      console.error('Logout failed:', error);
      setLoadingLogout(false);
      navigate('/login'); // Navigate anyway, but log the error
    });
}; 






  // Also set loading to false if user loaded but counts never fetch (fallback)
  useEffect(() => {
    if (user && !loadingCounts && firstCountsLoad.current) {
      setLoading(false);
    }
  }, [user, loadingCounts]);

  const handleComponentChange = (component) => {
    setActiveComponent(component);
    if (isMobile) setDrawerOpen(false);
  };

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);
  const handleGradesClick = () => setOpenGradesMenu(!openGradesMenu);


/// HandleProfileChange 2
  
      // Fetch user profile data on mount
  useEffect(() => {
    refreshUser();
  }, []);

  // inside your AdminDashboard component:

const refreshUser = async () => {
  try {
    const token = localStorage.getItem("access");
    const response = await api.get("/user-profile/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    setUser(response.data);
    setTempImage(null);
  } catch (error) {
    console.error("Failed to fetch user info", error);
    Swal.fire("Error", "Failed to load user info.", "error");
  }
};

const handleImageChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("profile_image", file);

  setTempImage(URL.createObjectURL(file));
  setOverlay(true);

  try {
    const token = localStorage.getItem("access");
    await api.put("/user-profile/", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    setTimeout(() => {
      Swal.fire("Success", "Profile image updated!", "success");
      setOverlay(false);
      refreshUser();
    }, 3000);
  } catch (err) {
    setOverlay(false);
    Swal.fire("Failed", "Could not update image.", "error");
    setTempImage(null);
  }
};
///Handle Profile 2 end

  if (loading) return <div>Loading...</div>;
  if (!user) return <div>Unable to load user.</div>;

  const chartData = {
    labels: ["Student", "Teacher", "School Fees", "Teachers' Salary"],
    datasets: [
      {
        label: "Analytics",
        data: [
          counts?.total_students || 0,
          counts?.total_teachers || 0,
          counts?.total_schoolfee || 0,
          counts?.total_salary || 0,
        ],
        backgroundColor: "rgba(0, 48, 87, 0.6)",
        borderColor: "#000",
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: { legend: { position: "top" } },
  };

const sidebarItems = [
  { label: "Home", icon: <HomeIcon />, comp: "admindashboard" },
  { label: "Create New Year", icon: <HomeIcon />, comp: "academicyearpost" }, 
  { label: "Payment Request", icon: <FaGraduationCap />, comp: "paymentrequestdetails" },
  { label: "Secure", icon: <HomeIcon />, comp: "adminresetpassword" },
  { label: "Admission", icon: <FaGraduationCap />, comp: "studentsadmission" },
  
  { label: "Class View List", icon: <FaChalkboard />, comp: "classviewlist" },
  { label: "Subject View List", icon: <FaBookReader />, comp: "subjectviewlist" },
  { label: "Division List", icon: <FaPagelines />, comp: "divisionlist" },

  { label: "Teacher Data", icon: <FaIdCard />, comp: "teacherdataform" },
  { label: "Teacher Tests", icon: <FaSchool />, comp: "testpraint" }, 
  { label: "Tests File", icon: <FaSchool />, comp: "testattachmentview" },
  { label: "Teacher Attendance", icon: <FaSchool />, comp: "teacherattendancedata" },
  
  { label: "Attendance Record", icon: <FaSchool />, comp: "attendancerecord" },
  { label: "Attendance Data", icon: <FaSchool />, comp: "attendancedata" },

  { label: "Publish Grades", icon: <FaChalkboardTeacher />, comp: "adminpublishgrades" },
  { label: "Semester Report", icon: <FaReceipt />, comp: "financedashboard" },
  { label: "Academy Report", icon: <HomeIcon />, comp: "academicreport" },
  { label: "Academy Report +", icon: <HomeIcon />, comp: "highaveragespage" }, 
  { label: "Students Report", icon: <HomeIcon />, comp: "studentstatussummary" },
  { label: "Students Assignments", icon: <FaClipboardList />, comp: "assignmentview" }, 
  { label: "Students Notes", icon: <FaClipboardList />, comp: "getstudentnotes" },
  
  { label: "Fees Record", icon: <FaMoneyBill />, comp: "financialpaymentrecord" },
  { label: "Fees Allocation", icon: <FaReceipt />, comp: "otherfee" },
  { label: "Clear & Arrears", icon: <FaReceipt />, comp: "paymentrecord" },
  
  
  { label: "Class Fees", icon: <FaGraduationCap />, comp: "schoolfeesdata" },
  

 
  { label: "Fees Summary", icon: <FaReceipt />, comp: "feessummary" },
  { label: "Monthly Records", icon: <FaReceipt />, comp: "monthlyfinancialrecord" }, 
  { label: "Expenditure", icon: <FaReceipt />, comp: "expenditure" },
  { label: "Loan", icon: <FaReceipt />, comp: "loan" }, 
  { label: "Bulk Grades", icon: <FaChalkboardTeacher />, comp: "bulktestscorepage" },

];


  return (
    <ThemeProvider theme={theme}>
     <Concern />
      <CssBaseline />
      <Box sx={{ display: "flex" }}>
        <AppBar
          position="fixed"
          sx={{
            zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#012442ff", // brown background
    color: "#afafb4ff", // gold color for icons/text
          }}
        >
          <Toolbar>
            {isMobile && (
              <IconButton
                color="inherit"
                edge="start"
                onClick={toggleDrawer}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}
           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  <Box
    component="img"
    src={gaasLogo}
    alt="GAAS Logo"
    sx={{
      width: 45,
      height: 45,
      borderRadius: "50%", // makes the logo perfectly round
      objectFit: "cover",
      border: "3px solid #57cefdff", // gold border
      boxShadow: "0 0 6px rgba(255, 255, 255, 0.4)",
    }}
  />
  <Typography
    variant="h6"
    noWrap
    component="div"
    sx={{
      fontFamily: "Milker, sans-serif",
      fontWeight: "bold",
      color: "#0cb1f1ff", // gold text color
      letterSpacing: 1.5,
    }}
  >
    MMI 
  </Typography>
</Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
  <Box>
    <UserSearchBox
      setSelectedUser={setSelectedUser}
      setActiveComponent={setActiveComponent}
    />
  </Box>
  
</Box>
            <Box sx={{ flexGrow: 1 }} />
     
      <Box>
         <Notice token={token} />
      </Box>
       <IconButton color="inherit" sx={{ mr: 1, '&:hover': { color: 'yellow', },}}>
              <NotificationIcon />
      </IconButton>
      
        

            

            

            <IconButton
              color="inherit"
              title="Add Class"
              onClick={() => setOpenAddClass(true)}
              sx={{ mr: 1, '&:hover': { color: 'yellow', },}}
            >
              <FaChalkboardTeacher />
            </IconButton>
            <IconButton
              color="inherit"
              title="Add Subject"
              onClick={() => setOpenAddSubject(true)}
              sx={{ mr: 1, '&:hover': { color: 'yellow', },}}
            >
              <FaBook />
            </IconButton>
            <IconButton
              color="inherit"
              title="Create Division"
              onClick={() => setOpenCreateDivision(true)}
              sx={{ mr: 1, '&:hover': { color: 'yellow', },}}
            >
              <FaSchool />
            </IconButton>
 
    <Link to="/chatApp" style={{ textDecoration: 'none' }}>
    <IconButton
  title="Users"
  sx={{
    mr: 1,
    color: 'white', // Default color
    '&:hover': {
      color: 'yellow', // Hover color
    },
  }}
>
  <FaUserFriends />
</IconButton>
    </Link>


<Button
  variant="outlined"
  color="inherit"
  sx={{
    borderColor: "white",
    color: "white",
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 100,
  }}
  onClick={handleLogout}
  disabled={loadingLogout}
>
  {loadingLogout ? (
    <CircularProgress size={20} sx={{ color: 'white' }} />
  ) : (
    <>
      <FaDoorOpen />
      <FaArrowRight />
    </>
  )}
</Button>

          </Toolbar>
        </AppBar>

        
               
                              

        <Drawer
          variant={isMobile ? "temporary" : "permanent"}
          open={isMobile ? drawerOpen : true}
          onClose={toggleDrawer}
          ModalProps={{ keepMounted: true }}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            backgroundColor: "#99c7fcff", // very light gold
      color: "#000000", // black icons/text
      borderRight: "1px solid #241401ff",
            },
          }}
        >
          <Toolbar />
{/* <Box sx={{ overflow: "auto" }}> */}
<Box
  sx={{
    overflow: "auto",
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-track": { background: "#000000" },        // black track
    "&::-webkit-scrollbar-thumb": { backgroundColor: "#FFFF00FF", borderRadius: "4px" }, // yellow thumb
    "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#f6f5fcff" }, // black on hover
  }}
>
  <List>
    {sidebarItems.map(({ label, icon, action, comp}) => {
      const key = label.toLowerCase().replace(/\s/g, "");
      const isActive = activeComponent === key;
      return (
   <ListItem
  button
  key={label}
  onClick={() => handleComponentChange(comp)}
  sx={{
    color: activeComponent === comp ? "#ffffff" : "#000000ff",
    backgroundColor: activeComponent === comp ? "#140344ff" : "transparent",
    "&:hover": { backgroundColor: "#e4e6e9ff", color: "#000a36ff" },
    fontWeight: activeComponent === comp ? "bold" : "normal",
    borderBottom: "1px solid #ddd",
  }}
>
  <ListItemIcon sx={{ color: "inherit" }}>{icon}</ListItemIcon>
  <ListItemText primary={label} />
</ListItem>
      );
    })}

    {/* Grades Reports Parent */}
    <ListItem
      button
      onClick={handleGradesClick}
      sx={{
        color: ["gradedistribution", "periodreport", "reportcard"].includes(
          activeComponent
        )
          ? "#ffffff"
          : "#000000ff",
        backgroundColor: ["gradedistribution", "periodreport", "reportcard"].includes(
          activeComponent
        )
          ? "#002e2aff"
          : "transparent",
        "&:hover": { backgroundColor: "#151f2bff", color: "#ffffff" },
        fontWeight: ["gradedistribution", "periodreport", "reportcard"].includes(
          activeComponent
        )
          ? "bold"
          : "normal",
        borderBottom: "1px solid #ddd",
      }}
    >
      <ListItemIcon sx={{ color: "inherit" }}>
        <FaPagelines />
      </ListItemIcon>
      <ListItemText primary="Grades Reports" />
      {openGradesMenu ? <ExpandLess /> : <ExpandMore />}
    </ListItem>

    {/* Grades Reports Children */}
    <Collapse in={openGradesMenu} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {[
          { label: "Grade Distribution", icon: <FaPagelines />, comp: "gradedistribution" },
          { label: "Periodic Grades", icon: <FaCashRegister />, comp: "periodreport" },
          { label: "Report Cards", icon: <FaIdCard />, comp: "reportcard" },
        ].map(({ label, icon, comp }) => {
          const isActive = activeComponent === comp;
          return (
            <ListItem
              button
              key={label}
              onClick={() => handleComponentChange(comp)}
              sx={{
                pl: 4,
                color: isActive ? "#ffffff" : "#000000ff",
                backgroundColor: isActive ? "#441e03ff" : "transparent",
                "&:hover": { backgroundColor: "#441e03ff", color: "#ffffff" },
                fontWeight: isActive ? "bold" : "normal",
                borderBottom: "1px solid #ddd",
              }}
            >
              <ListItemIcon sx={{ color: "inherit" }}>{icon}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItem>
          );
        })}
      </List>
    </Collapse>
  </List>
</Box>


        </Drawer>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            mt: -6,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            overflowY: "auto",
            maxHeight: "calc(100vh - 64px)",
          }}
        >
          {activeComponent === "register" && <Register />}
          {activeComponent === "schedule" && <Schedule />}
          {activeComponent === "schedulepage" && <SchedulePage />}
          {activeComponent === "schedulepagetrack" && <SchedulePageTrack />}
          {activeComponent === "financialpaymentrecord" && (
            <FinancialPaymentRecord />
          )}
          {activeComponent === "studentsadmission" && (
            <StudentsAdmission />
          )}
         
         
          {activeComponent === "adminpublishgrades" && <AdminPublishGrades />}
         
          {activeComponent === "classviewlist" && <ClassViewList />}
          {activeComponent === "subjectviewlist" && <SubjectViewList />}
          {activeComponent === "divisionlist" && <DivisionList />}
          {activeComponent === "gradedistribution" && <GradeDistribution />}
          {activeComponent === "periodreport" && <PeriodReport />}
          {activeComponent === "reportcard" && <ReportCard />}
          {activeComponent === "teacherdataform" && <TeacherDataForm />}
          {activeComponent === "attendancerecord" && <AttendanceRecord />}
          {activeComponent === "attendancedata" && <AttendanceData />}
          {activeComponent === "highaveragespage" && <HighAveragesPage />}
          {activeComponent === "payroll" && <Payroll />}
          {activeComponent === "supportstaff" && <SupportStaff />}
          {activeComponent === "salaryadvance" && <SalaryAdvance />} 
          {activeComponent === "financedashboard" && <FinanceDashboard />}
          {activeComponent === "expenditure" && <Expenditure />}
          {activeComponent === "otherfee" && <OtherFee />}
          {activeComponent === "monthlyfinancialrecord" && <MonthlyFinancialRecord />}
          {activeComponent === "loan" && <Loan />}
          {activeComponent === "testpraint" && <TestPraint />}
          
          {activeComponent === "schoolfeesdata" && <SchoolFeesData />}
          {activeComponent === "adminresetpassword" && <AdminResetPassword />} 
          {activeComponent === "testattachmentview" && <TestAttachmentView />}
          {activeComponent === "academicyearpost" && <AcademicYearPost />}
          {activeComponent === "academicreport" && <AcademicReport />}
          {activeComponent === "studentstatussummary" && <StudentStatusSummary />}  
          {activeComponent === "teacherattendancedata" && <TeacherAttendanceData />}
          {activeComponent === "feessummary" && <FeesSummary/>} 
          {activeComponent === "paymentrecord" && <PaymentRecord/>}
          {activeComponent === "assignmentview" && <AssignmentView />} 
           {activeComponent === "getstudentnotes" && <GetStudentNotes />}
           {activeComponent === "bulktestscorepage" && <BulkTestScorePage/>}
          {activeComponent === "paymentrequestdetails" && <PaymentRequestDetails/>} 
      
          {/* {activeComponent === "userdetailspage" && <UserDetailsPage />} */} 
          {activeComponent === "userdetailspage" && (
          <UserDetailsPage
            selectedUser={selectedUser}
            goBack={() => {
              setActiveComponent("admindashboard");
              setSelectedUser(null);
            }}
          />
        )}
          


          {activeComponent === "admindashboard" && (
            <>
              <Box sx={{ overflow: "hidden" }}>
                {/* <Paper
                  elevation={0}
                  sx={{
                    width: "98%",
                    maxWidth: "100%",
                    maxHeight: "calc(100vh - 20px)",
                    overflowY: "auto",
                    mx: "auto",
                    p: 2,
                    bgcolor: "#f5f5f5",
                  }}
                > */}
                <Paper
  elevation={0}
  sx={{
    width: "98%",
    maxWidth: "100%",
    maxHeight: "calc(100vh - 20px)",
    overflowY: "auto",
    mx: "auto",
    p: 2,
    // Background image with dim overlay
    backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "#fff", // optional, if you want text to be readable
  }}
>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    direction={isMobile ? "column" : "row"}
                  >
                    <Grid item>
            

<Box sx={{ position: "relative", width: 100, height: 100, mx: "auto" }}>
  <Avatar
    alt={user.username}
    src={
      tempImage
        ? tempImage
        : user.profile_image
        ? `https://www.messiahmissioninstitute.online${user.profile_image}`
        : "/default.jpg"
    }
    sx={{
      width: 100,
      height: 100,
      border: "4px solid navy", 
    }}
  />

  {/* Overlay loader if needed */}
  <Box
    className="avatar-overlay"
    style={{
      display: overlay ? "flex" : "none",
    }}
  >
    <div className="three-dots">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </Box>

  {/* Upload input */}
  <input
    type="file"
    accept="image/*"
    id="upload-avatar"
    style={{ display: "none" }}
    onChange={handleImageChange}
  />
  <label htmlFor="upload-avatar">
    <IconButton
      sx={{
        position: "absolute",
        bottom: -8,
        right: -8,
        backgroundColor: "#79b3ffff",
        border: "1px solid #ccc",
        boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
        "&:hover": { backgroundColor: "#eee" },
        zIndex: 20,
        width: 32,
        height: 32,
      }}
      component="span"
    >
      <CameraAltIcon sx={{ fontSize: "18px" }} />
    </IconButton>
  </label>
</Box>

                     
                    </Grid>
                    <Grid item>
                      <Typography variant="h6" fontWeight="bold">
                        {user.username}
                      </Typography>
                      <Typography variant="body1" sx={{ color: "#fafafaff" }}>
                        {user.email}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#fafafaff" }}>
                        {user.user_type}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={{ my: 2 }} />
                  {/* //Add user// */}
                 <Box sx={{ mt: 2 }}>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      flexWrap: isMobile ? "wrap" : "nowrap",
    }}
  >
    {/* Previous arrow for mobile */}
    {isMobile && startIndex > 0 && (
      <IconButton
        onClick={handlePrev}
        size="small"
        sx={{
          "&:hover": { backgroundColor: "#ffffff33", color: "white" },
          "&:active": { backgroundColor: "#ffffff66", color: "white" },
        }}
      >
        <ArrowBackIos sx={{ fontSize: 16 }} />
      </IconButton>
    )}

    {/* Buttons container */}
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flex: 1,
        alignItems: "center",
        flexWrap: "nowrap",
        overflowX: isMobile ? "hidden" : "auto",
      }}
    >
      {displayedButtons.map((btn) => (
        <Button
          key={btn.component}
          onClick={() => handleComponentChange(btn.component)}
          variant="outlined"
          sx={{
            borderColor: "white",
            color: "white",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "white",
              color: "#001F3D",
              borderColor: "white",
            },
            flex: isMobile ? "1 1 45%" : "1 1 auto", // mobile: two buttons per row
            minWidth: 100,
            fontSize: isMobile ? "0.75rem" : "0.875rem", // smaller text on mobile
            padding: isMobile ? "4px 8px" : "6px 16px",
          }}
        >
          {btn.label}
        </Button>
      ))}

      {/* AcademicYear on desktop inside same row */}
      {!isMobile && (
        <Box sx={{ ml: 2, flexShrink: 0 }}>
          <AcademicYear />
        </Box>
      )}
    </Box>

    {/* Next arrow for mobile */}
    {isMobile && startIndex + 2 < buttons.length && (
      <IconButton
        onClick={handleNext}
        size="small"
        sx={{
          "&:hover": { backgroundColor: "#ffffff33", color: "white" },
          "&:active": { backgroundColor: "#ffffff66", color: "white" },
        }}
      >
        <ArrowForwardIos sx={{ fontSize: 16 }} />
      </IconButton>
    )}
  </Box>

  {/* AcademicYear on mobile */}
  {isMobile && (
    <Box sx={{ mb: 1, mt: 1 }}>
      <AcademicYear />
    </Box>
  )}
</Box>

                </Paper>
              </Box>

              <Box sx={{ mt: 6, p: 2 }}>
                  <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      {/* Students Card */}
      <Card
        sx={{
          flex: 1,
          minWidth: 200,
          borderRadius: 3,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          bgcolor: "#323233ff", // light tin color
          color: "#a7f5f1ff",
          "&:hover": { transform: "translateY(-3px)", boxShadow: "0 6px 15px rgba(0,0,0,0.15)" },
          transition: "0.3s",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <SchoolIcon sx={{ fontSize: 40, color: "#1b819aff" }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Students
            </Typography>
            <Typography variant="h5">{counts?.total_students ?? 0}</Typography>
          </Box>
        </CardContent>
      </Card>

      {/* Teachers Card */}
      <Card
        sx={{
          flex: 1,
          minWidth: 200,
          borderRadius: 3,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          bgcolor: "#85dafcff", // light tin color
          color: "#000000ff",
          "&:hover": { transform: "translateY(-3px)", boxShadow: "0 6px 15px rgba(0,0,0,0.15)" },
          transition: "0.3s",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <PeopleIcon sx={{ fontSize: 40, color: "#241401ff" }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Teachers
            </Typography>
            <Typography variant="h5">{counts?.total_teachers ?? 0}</Typography>
          </Box>
        </CardContent>
      </Card>

      {/* School Fees Card */}
      <Card
        sx={{
          flex: 1,
          minWidth: 200,
          borderRadius: 3,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            bgcolor: "#ffd92eff", // light tin color
          color: "#000000ff",
          "&:hover": { transform: "translateY(-3px)", boxShadow: "0 6px 15px rgba(0,0,0,0.15)" },
          transition: "0.3s",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <PaidIcon sx={{ fontSize: 40, color: "#010b27ff" }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              School Fees
            </Typography>
            <Typography variant="h5">${counts?.total_schoolfee?.toLocaleString() ?? 0}</Typography>
          </Box>
        </CardContent>
      </Card>

      {/* Staff Salary Card */}
      <Card
        sx={{
          flex: 1,
          minWidth: 200,
          borderRadius: 3,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          bgcolor: "#f7b654ff", // light tin color
          color: "#000000ff",
          "&:hover": { transform: "translateY(-3px)", boxShadow: "0 6px 15px rgba(0,0,0,0.15)" },
          transition: "0.3s",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <AttachMoneyIcon sx={{ fontSize: 40, color: "#001825ff" }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Staff Salary
            </Typography>
            <Typography variant="h5">${counts?.total_salary?.toLocaleString() ?? 0}</Typography>
          </Box>
        </CardContent>
      </Card>

      {/* Total Expenditure Card */}
      <Card
        sx={{
          flex: 1,
          minWidth: 200,
          borderRadius: 3,
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          bgcolor: "#323233ff", // light tin color
          color: "#a7f5f1ff",
          "&:hover": { transform: "translateY(-3px)", boxShadow: "0 6px 15px rgba(0,0,0,0.15)" },
          transition: "0.3s",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <AccountBalanceIcon sx={{ fontSize: 40, color: "#a7f0abff" }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Total Expenditure
            </Typography>
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              <Typography variant="h5" sx={{ mt: 0.5 }}>
                ${parseFloat(total).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>

                <Grid container spacing={4} sx={{ mt: 4 }}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" align="center" gutterBottom>
                      Dashboard Analytics <SubjectCountView />
                    </Typography>
                    <Bar data={chartData} options={chartOptions} />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography variant="h5" align="center" gutterBottom>
                      Dashboard Analytics <GradeClassCount />
                    </Typography>
                    <Bar data={chartData} options={chartOptions} />
                    
                  </Grid>
                </Grid>
 <StudentStatsDashboard />
              </Box>
            </>
          )}
        </Box>

        <AddClass open={openAddClass} handleClose={() => setOpenAddClass(false)} />
        <AddSubject
          open={openAddSubject}
          handleClose={() => setOpenAddSubject(false)}
        />
        <CreateDivision
          open={openCreateDivision}
          handleClose={() => setOpenCreateDivision(false)}
        />
 
   

      </Box>

    
        <PaymentRequestView />
      

    </ThemeProvider>
  );
};

export default AdminDashboard;